import {
	type ReactNode,
	createContext,
	useContext,
	useMemo,
	useState,
} from "react";

export type NavActiveSource = "my-boards" | "favourites" | "shared-with-me";

interface NavActiveSourceContextType {
	activeSource: NavActiveSource;
	setActiveSource: (source: NavActiveSource) => void;
}

const NavActiveSourceContext = createContext<
	NavActiveSourceContextType | undefined
>(undefined);

NavActiveSourceContext.displayName = "NavActiveSourceContext";

export function NavActiveSourceProvider({
	children,
}: {
	children: ReactNode;
}) {
	const [activeSource, setActiveSource] =
		useState<NavActiveSource>("my-boards");

	const value = useMemo(
		() => ({ activeSource, setActiveSource }),
		[activeSource],
	);

	return (
		<NavActiveSourceContext.Provider value={value}>
			{children}
		</NavActiveSourceContext.Provider>
	);
}

export function useNavActiveSource() {
	const context = useContext(NavActiveSourceContext);
	if (!context) {
		throw new Error(
			"useNavActiveSource must be used within a NavActiveSourceProvider",
		);
	}
	return context;
}
